import React, { useState } from 'react'
import { Checkbox, Form, Schema } from 'rsuite';
import { TextField } from '../../../helpers/FormControlRSuit';

export const Step3 = ({contrato, handleNext}) => {
    const [form, setform] = useState({});

    const handleSubmit = () => {
        if (!form.check()) {
            return;
        } 
        handleNext();
    }
    return (
        <Form
            fluid
            ref={ref => (setform(ref))}
            model={model}
            inline
        >
            <div className="row">
                <div className="col-12">
                    <div className="text-center">
                        <h3 className="mt-0">¡ Tu contrato esta listo !</h3>
                        <p className="w-75 mb-4 mx-auto">Lee cuidadosamente tu contrato antes de aceptar el mismo.</p>
                        <div className="row mb-3 text-left"  dangerouslySetInnerHTML={{__html: contrato}}></div>
                        <div className="row mb-3">
                            <TextField 
                                name="acepto"
                                accepter={Checkbox}
                                value={'1'}
                            >
                                Estoy deacuerdo con el contrato anterior.
                            </TextField>
                        </div>
                    </div>
                </div>
                {/* end col */}
            </div>
            {/* end row */}
            <button type="button" onClick={handleSubmit} className="btn btn-primary btn-lg btn-block">Continuar</button>
        </Form>
    );
}

const { StringType} = Schema.Types;

let model = Schema.Model({
    acepto: StringType()
      .isRequired('Es necesario que leas y aceptes tu contrato.'),
});
